import { render, staticRenderFns } from "./DlgEventInvitationEdit.vue?vue&type=template&id=51d6f999&scoped=true"
import script from "./DlgEventInvitationEdit.vue?vue&type=script&lang=ts"
export * from "./DlgEventInvitationEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d6f999",
  null
  
)

export default component.exports